<template>
  <div class="table-form table-responsive">
    <button @click="createUser" type="button" class="theme-btn"><i class="la la-plus mr-1"></i>Yeni Çalışan Ekle</button>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Email</th>
        <th>Adı Soyadı</th>
        <th>Telefon Numarası</th>
        <th>Adres</th>
        <th>Aktif</th>
        <th>Güncelle</th>
        <th>Şifre değiştir</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in userList">
        <th scope="row">{{ user.email }}</th>
        <th>{{ user.name }} {{ user.lastName }}</th>
        <th>{{ user.phoneNumber }}</th>
        <th>{{ user.address }}</th>
        <th v-if="user.active"><span class="badge badge-success py-1 px-2">✓</span></th>
        <th v-if="!user.active"><span class="badge badge-danger py-1 px-2">x</span></th>
        <th>
          <div class="table-content row" @click="showUserDetail(user)">
            <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit"><i class="la la-edit"></i></a>
          </div>
        </th>
        <th>
          <div class="table-content row" @click="showChangePassword(user)">
            <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit"><i class="la la-edit"></i></a>
          </div>
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "AgencyUserList",
  computed:{
    userList:{
      get(){
        return this.$store.getters.getAgencyUserList;
      }
    }
  },
  methods:{
    showUserDetail(user){
      let editUser = JSON.parse(JSON.stringify(user));

      this.$store.commit("setUser", editUser)
      $("#agencyUserPopup").modal('show')
    },
    createUser(){
      this.$store.commit("setUser", {id:null})
      $("#agencyUserPopup").modal('show')
    },
    showChangePassword(user){
      user.password = "";
      let editUser = JSON.parse(JSON.stringify(user));
      this.$store.commit("setUser", editUser)
      $("#agencyPasswordPopup").modal('show')
    },
  }
}
</script>

<style scoped>
.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn-small{
  color: white!important;
}

</style>